import { render, staticRenderFns } from "./AgreementList.vue?vue&type=template&id=1bd4dc10&"
import script from "./AgreementList.vue?vue&type=script&lang=js&"
export * from "./AgreementList.vue?vue&type=script&lang=js&"
import style0 from "./AgreementList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports